import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TW_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TW_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#EF0000"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TW_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TW_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v14h18V0H0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.729 10.81L7.247 12.66l-.359-2.342-2.207.86.86-2.207-2.342-.36 1.849-1.48-1.849-1.482 2.342-.36-.86-2.207 2.207.86.36-2.341 1.48 1.848L10.21 1.6l.36 2.341 2.207-.86-.86 2.208 2.341.359-1.848 1.481 1.848 1.482-2.341.359.86 2.207-2.208-.86-.359 2.342L8.73 10.81zm0-.818a2.862 2.862 0 100-5.725 2.862 2.862 0 000 5.725zm2.29-2.862a2.29 2.29 0 11-4.58 0 2.29 2.29 0 014.58 0z",
      fill: "#FEFFFF"
    }
  )))
), a = t;
export {
  a as default
};
